import React from "react";
import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TableListKpis from "@/pages/Kpis/Componennts/TableListKpis";

export type CatchmentCampaignPageProps = {
  isLoading: any;
  isError: boolean;
  people: any;
};

const CatchmentCampaignPage: React.FC<CatchmentCampaignPageProps> = ({
  isLoading,
  isError,
  people,
}) => {
  return (
    <>
      {isLoading && (
        <div className="flex justify-center items-center h-90 mt-20">
          <FontAwesomeIcon icon={faLoader} spin className="text-6xl" />
        </div>
      )}
      {isError && <p>Error fetching data</p>}
      {!isLoading && !isError && <TableListKpis people={people} />}
    </>
  );
};

export default CatchmentCampaignPage;
